import axios from 'axios';
import { environment } from '@environments/environment';
import { ProductDataType, ProductType } from '@pages/product-analyzer/Product';
import { sortFilters, sortPriceBandOptions } from '@utils/FilterSettings';
import { FilterKeys, Filters } from '@utils/pageConfig/Types';
import { paramsSerializer } from './utils/OverviewServiceUtils';
import { formatPeriodType } from '@utils/PeriodUtils';

/*
 * function that gets the feature values/filter & filter options based on retailer+country+periodType+PG
 */
export const getFeatureValueByPGAndCountry = async (params: {
  clientId: number;
  productType: ProductType;
  productDataType: ProductDataType;
  country: string[];
  periodType: string;
  productGroups: string[];
  currentTotalName: string;
  signal?: AbortSignal;
  includeCommonFeaturesOnly?: boolean;
}): Promise<Filters[]> => {
  const {
    clientId,
    productType,
    productDataType,
    country,
    periodType,
    productGroups,
    signal,
    currentTotalName,
    includeCommonFeaturesOnly = false,
  } = params;
  try {
    const countriesParam = country.map((c) => encodeURIComponent(c.toUpperCase())).join('&country=');

    let { data } = await axios.get<Filters[]>(`${environment.baseUrl}/v2/filters/feature-value`, {
      params: {
        clientId: clientId,
        productType,
        productDataType,
        country: countriesParam,
        periodType: formatPeriodType(periodType),
        productGroup: productGroups.map((pg) => encodeURIComponent(pg.toUpperCase())),
        includeCommonFeaturesOnly,
      },
      paramsSerializer: paramsSerializer,
      signal,
    });
    data = sortFilters(data);
    // eslint-disable-next-line array-callback-return
    data.forEach((filter) => {
      const index = [...filter.options].findIndex((o) => o.label === currentTotalName);
      const panelMarketIndex = [...filter.options].findIndex((o) => o.label === 'PANELMARKET');
      const notachannelIndex = [...filter.options].findIndex((o) => o.label === 'NOTACHANNEL');

      if (index !== -1) {
        filter.options.splice(index, 1);
      }

      if (panelMarketIndex !== -1) {
        filter.options.splice(panelMarketIndex, 1);
      }

      if (notachannelIndex !== -1) {
        filter.options.splice(notachannelIndex, 1);
      }

      if (filter.filterKey === FilterKeys.PRICEBAND) {
        filter.options = sortPriceBandOptions(filter.options);
      }
    });
    return data;
  } catch (err: any) {
    console.error(err);
    return [];
  }
};
